module.exports = __webpack_public_path__ + "img/garden_menu_6.75617e8e.png";